import { useContext } from "react";
import UserContext from "../../contexts/UserContext";
import { Spinner } from "react-bootstrap";

export default function Waccount({ account, position, onclick, using }) {
    // states
    const { user } = useContext(UserContext);


    // comportements


    // Affichage
    return (
        <tr style={{ borderStyle: "none" }}>
            <td className="text-center">{position + 1}</td>
            <td>{account?.prof}</td>
            <td>{account?.login}</td>
            <td>{account?.mdp}</td>
            <td>
                <span
                    className={`badge ${account.etat === 1 ? "badge-success" :
                            account.etat === 2 ? "badge-warning" :
                                (account.etat === 3 || account.etat === 10) ? "badge-danger" :
                                    ""
                        } mt-2`
                    }
                    style={{ fontSize: 14, }}>
                    {
                        account.etatdef !== null ? account?.etatdef :
                            "Etat"
                    }
                </span>
            </td>
            <td>{account?.datecrea.slice(0, 16).replace("T", " à ")}</td>
            <td className="text-center">
                {(user?.isFullAction || user?.isAdminAction || user?.isViderTicket) && account.etat === 1 &&
                    <button onClick={onclick} data-toggle="tooltip" title={"Utiliser ce compte"} data-placement="left" className="btn-shadow-danger mr-2 ml-2 btn btn-sm btn-danger">
                        <i className="fa fa-share"></i>  {using && <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />}
                    </button>
                }
            </td>
        </tr>
    )
}